import { Box, FormControl, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react'
// import "react-select/dist/react-select.css";
import Select, { StylesConfig } from "react-select";
import chroma from 'chroma-js';
import Highlighter from "react-highlight-words";
import { Margin } from '@mui/icons-material';
import CommonStyles from './CommonStyles';
import { components } from "react-select";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
   Select:{
    // zIndex: 1
   },
   margin: {
    width: "100%",
    "& >div > div": {
      width: "100%",
    },
  },
  Box: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    "@media screen and (max-width:980px)": {
      display: "block",
    },
  },
  title: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    minWidth: "150px",
    "@media screen and (max-width:980px)": {
      marginBottom: "5px",
    },
  },
  })
);



const CustomMultiselect = (props:any) => {
  const {isMulti , placeholder,defaultValue, options, handleChange,isDisabled,isColor,width,required,title='',classNames=''}:{isMulti: boolean, defaultValue:  Array<[]>, options: any,handleChange: any, isDisabled: boolean,isColor: boolean,width: any,placeholder: any,title:string | undefined | null, classNames: string | undefined | null,required:boolean} = props;
  const colourStyles: StylesConfig<any> = {
    control: (styles) => ({ ...styles, backgroundColor: 'white',    width: width, minWidth: width,
    minHeight: 50}),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data?.color ? data?.color : "gray");
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? color.alpha(0.1).css()
          : undefined,
        color: isDisabled
          ? '#ccc'
          : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'blue'
            : 'black'
          : data.color,
        cursor: isDisabled ? 'not-allowed' : 'default',
  
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      const color = chroma(data?.color ? data?.color : "gray");
      return {
        ...styles,
        backgroundColor: color.alpha(0.1).css(),
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: data.color,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: data.color,
      ':hover': {
        backgroundColor: data.color,
        color: 'white',
      },
    }),
  }; 
  // const MyOption = (props : any) => {
  //   const { innerProps, innerRef } = props;
  //   let a =[props.selectProps.inputValue];
  //   return (
  //     <div ref={innerRef} {...innerProps} style={{margin: "10px"}}>
  //       <Highlighter
  //   highlightClassName="YourHighlightClass"
  //   searchWords={a}
  //   autoEscape={false}
  //   textToHighlight={props.data.label}
  // />
  //     </div>
  //   );
  // };
  const { Option } = components;
  const MyOption = (props: any) => {
    const { innerRef, innerProps } = props;
    const a = [props.selectProps.inputValue];
    return (
      <Option {...props}>
        <div ref={innerRef} {...innerProps}style={{width: "100%", display: "block",}}>
          <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={a}
            autoEscape={false}
            textToHighlight={props.data.label}
          />
        </div>
      </Option>
    );
  };
  const classes = useStyles();
  const optionsWithSelect : any = isMulti && options?.length > 0
      ? [{ label: "Select All", value: "all" }, ...options]
      : options;
    const commonStyles = CommonStyles();
    return (
      <div className={`${commonStyles.row} custom-multiselect-dropdown ${commonStyles.title} ${classNames}`}>
        {title !== '' && 
          <Box>
            <FormControl className={classes.margin}>
              <Box className={`${classes.Box}`}>
                <Typography className={`${classes.title}${commonStyles.themeColorTxt}`} style={{fontSize: "14px",}}>
                  {title} {required && <span className={commonStyles.dangerTxt}> *</span>}
                </Typography>
              </Box>
            </FormControl>
          </Box>
        }
        <div className='col'>
          <div className={`react-select-wrapper  ${isMulti ? "multi" : ""}`} style={{ zIndex:1}}>
            {/* //width:width, */}
          <Select
          classNamePrefix="myselect"
          className={`custom-multiselect-dropdowns ${classNames || ""}`}
          placeholder={placeholder && placeholder}
          // className={classes.Select}
          isDisabled={isDisabled}
          styles={{
          ...(isColor ? colourStyles : {}),
          placeholder: (styles) => ({
            ...styles,
            fontSize: '14px',
            color:'#c8c8c8'
          }),
          }}
            options={optionsWithSelect}
            components={{Option: MyOption}}
            isMulti={isMulti}
            value={defaultValue ? defaultValue : null}
            onInputChange={(e)=>{

            }}
            onChange={(selected : any) => {
              isMulti &&
              selected.length &&
              selected.find((option : any) => option.value === "all")
                ? handleChange(optionsWithSelect.slice(1))
                : !isMulti
                ? handleChange((selected && selected) || null)
                : handleChange(selected);
            }}
          />
          </div>
        </div>
      </div>
      
    );
  };

export default CustomMultiselect